import { getCookie } from "../browser"


export const getB2ECountryDomain = (hostname?: string): string => {
    const selectedCountry = getCookie('selected_country')
    const domain = hostname || window.location.hostname
    if((domain === 'localhost' || domain === 'b2e.flyin.com') && selectedCountry) {
        return window.location.hostname + '_' + selectedCountry
    }
    return domain
}